import { UAParser } from "ua-parser-js";

async function getFullBrowserVersion(): Promise<string | null> {
  if ((navigator as any).userAgentData?.getHighEntropyValues) {
    try {
      const { fullVersionList, brands } = await (navigator as any).userAgentData.getHighEntropyValues(["fullVersionList"]);
      const list = fullVersionList || brands || [];
      const match = list.find((b: { brand: string; version: string }) => !/not.?a.?brand/i.test(b.brand));
      return match?.version ?? null;
    } catch {
      return null;
    }
  }
  return null;
}

export async function getMetaInfo() {
  const parser = new UAParser();
  const { browser, os, device, ua } = parser.getResult();

  const fullVersion = await getFullBrowserVersion();

  return {
    browser: {
      name: browser.name ?? null,
      version: fullVersion ?? browser.version ?? null,
    },
    os: {
      name: os.name ?? null,
      version: os.version ?? null,
    },
    device: {
      type: device.type ?? "desktop",
      model: device.model ?? null,
      name: [device.vendor, device.model].filter(Boolean).join(" ") || os.name || null,
    },
    user_agent: ua,
    language: navigator.language ?? null,
    screen: {
      width: window.screen?.width ?? null,
      height: window.screen?.height ?? null,
    },
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone ?? null,
  };
}
